/**
 * AspectRatioIcon — пропорциональный SVG-thumbnail соотношения сторон из
 * строки «W:H» (напр. «16:9», «4:5», «5:4»). Рисует прямоугольник в реальной
 * пропорции внутри 16×16 viewBox; `stroke=currentColor` наследует цвет
 * текста/состояния родителя.
 *
 * Единый источник для всех пикеров размера: виджет генерации
 * (SettingsPillsRow), ProductCardLab «Формат карточки» и т.д. Динамический
 * расчёт (calcRect) рисует ЛЮБОЙ ratio, а не хардкод-набор — поэтому корректно
 * показывает и 5:4 / 4:5, и панорамы 21:9.
 */
function calcRect(w: number, h: number) {
	const maxW = 14
	const maxH = 14
	const aspect = w / h
	let rw: number
	let rh: number
	if (aspect >= 1) {
		rw = maxW
		rh = Math.round(maxW / aspect)
	} else {
		rh = maxH
		rw = Math.round(maxH * aspect)
	}
	rw = Math.max(rw, 3)
	rh = Math.max(rh, 3)
	const x = (16 - rw) / 2
	const y = (16 - rh) / 2
	return { x, y, w: rw, h: rh }
}

export function AspectRatioIcon({ ratio, size = 14 }: { ratio: string; size?: number }) {
	// «По изображению» (nano-banana match_input_image) — рамка с плюсом.
	if (ratio === 'match_input_image') {
		return (
			<svg width={size} height={size} viewBox="0 0 16 16" fill="none">
				<rect x="1" y="1" width="14" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
				<path d="M5 8h6M8 5v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			</svg>
		)
	}
	const parts = ratio.split(':')
	if (parts.length === 2) {
		const w = parseFloat(parts[0])
		const h = parseFloat(parts[1])
		if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0) {
			const { x, y, w: rw, h: rh } = calcRect(w, h)
			return (
				<svg width={size} height={size} viewBox="0 0 16 16" fill="none">
					<rect x={x} y={y} width={rw} height={rh} rx="1.5" stroke="currentColor" strokeWidth="1.5" />
				</svg>
			)
		}
	}
	// Неизвестный формат — нейтральный квадрат.
	return (
		<svg width={size} height={size} viewBox="0 0 16 16" fill="none">
			<rect x="3" y="3" width="10" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
		</svg>
	)
}

export default AspectRatioIcon
